import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { GovernyInfo } from "../../../lib/types";
import { abdicate, closeDialog, setError } from "../../../store/actions";

const mapStateToProps = (state: any) => ({
  id: state.governorate.id,
  alliance: state.governorate.alliance,
  error: state.ui.error
});

const mapDispatchToProps = (dispatch: any) => ({
  closeDialogDispatch: () => dispatch(closeDialog()),
  abdicateDispatch: (
    password: string,
    newEmperorId: number
  ) => dispatch(abdicate(password, newEmperorId)),
  setErrorDispatch: (error?: string) => dispatch(setError(error))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const Abdication = ({
  id,
  alliance,
  error,
  closeDialogDispatch,
  abdicateDispatch,
  setErrorDispatch
}: ConnectedProps<typeof connector>) => {
  const handingOverEmperor = alliance && alliance.emperor.id === id && alliance.members.length > 1;

  const [newEmperor, setNewEmperor] = useState<number>(handingOverEmperor
    ? alliance.members.filter((m: GovernyInfo) => m.id !== id)[0].id : 0);
  const [password, setPassword] = useState<string>("");

  useEffect(() => {
    setErrorDispatch();
    return () => setErrorDispatch();
  }, []);

  const handleChangePassword = (newPassword: string) => {
    setPassword(newPassword);
    setErrorDispatch();
  }

  return (
    <>
      <div className={"dialog-content"}>
        {handingOverEmperor && <>
          <table className="table">
            <tr>
              <td>
                You are the emperor of the alliance and you&nbsp;
                have to hand over the emperor before abdication.
              </td>
            </tr>
          </table>
          <table className="table">
            <tr>
              <td><strong>New emperor</strong></td>
              <td>
                <div className="dropdown">
                  <select
                    className="input"
                    onChange={e => setNewEmperor(Number.parseInt(e.target.value, 10))}
                  >
                    {alliance.members.filter((m: GovernyInfo) => m.id !== id)
                      .map((member: GovernyInfo, i: number) => <option
                        selected={(!newEmperor && !i) || newEmperor === member.id}
                        value={member.id}
                      >
                        {member.name}
                      </option>)}
                  </select>
                </div>
              </td>
            </tr>
          </table>
        </>}
        {alliance && alliance.members.length === 1 && <table className="table">
          <tr>
            <td>You are the last member. Your alliance will be disbanded.</td>
          </tr>
        </table>}
        <table className="table">
          <tr>
            <td>
                If you want to abdicate your governorate,&nbsp;
                confirm action with password to game account.
              <br/>
              <br/>
              <input
                type="password"
                onChange={e => handleChangePassword(e.target.value)}
                className="input"
                placeholder="Enter password"
              />
              {error && <div className="negative">{error}</div>}
            </td>
          </tr>
        </table>
      </div>
      <footer className={"dialog-footer"}>
        <a
          className="btn btn-blank btn-no-width"
          onClick={closeDialogDispatch}
        >
          Cancel
        </a>
        <button
          className={`btn btn-blank btn-no-width ${password && password.length ? "" : "disabled"}`}
          onClick={() => password && password.length && abdicateDispatch(password, newEmperor)}
        >
          Abdicate
        </button>
      </footer>
    </>
  )
}

export default connector(Abdication);
